import React, { Component } from 'react';
import Top_Bar from '../../Part_Sample/Top_Bar';
import { navigateReport } from '../../Common/navigation';
import { isEmpty, getLocale, makeTimeString } from '../../Common/Common';
// Charts
import Total_Hourly_Bar_Chart from './Charts/Total_Hourly_Bar_Chart';
import Categories_Pie_Charts from './Charts/Categories_Pie_Charts';
// Tables
import Total_Energy_Consumption from './Tables/Total_Energy_Consumption';
import Total_Energy_Generator from './Tables/Total_Energy_Generator';
import Total_Water_Consumption from './Tables/Total_Water_Consumption';
import Energy_Categories from './Tables/Energy_Categories';
import Energy_Devices from './Tables/Energy_Devices';
import Water_Devices from './Tables/Water_Devices';

export default class Realtime extends Component {
	constructor(props) {
		super(props);
		let data = {};
		if (!isEmpty(this.props.param.data)) data = this.props.param.data;

		this.state = {
			data: data,
			chart_state: 'pie_chart',
			total_state: 'total_energy',
			breakdown_state: 'energy_device',
		}

		this.chart_interval = setInterval(() => { this.changeChartState(false) }, 20000);
		this.total_interval = setInterval(() => { this.changeTotalState(false) }, 20000);
		this.breakdown_interval = setInterval(() => { this.changeBreakdownState(false) }, 20000);

		this.total_hourly_bar_chart = React.createRef();
		this.categories_pie_charts = React.createRef();
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleShowBottomMenu();
		navigateReport("null");
	}

	rcvRealtimeEnergyCos = (data) => {
		let new_data = JSON.parse(JSON.stringify(this.state.data))
		for (let id in data) {
			new_data[id].month = data[id].month;
			new_data[id].day = data[id].day;
			new_data[id].hour = data[id].hour;
			new_data[id].daily[data[id].date_index] = new_data[id].day;
			new_data[id].hourly[data[id].hour_index] = new_data[id].hour;
		}

		this.setState({ data: new_data }, () => {
			this.total_hourly_bar_chart.current.refreshChart();
			this.categories_pie_charts.current.refreshChart();
		})
	}

	changeChartState = (is_clicked) => {
		let chart_state = this.state.chart_state;
		if (chart_state == 'pie_chart') {
			chart_state = 'energy_chart';
		} else if (chart_state == 'energy_chart') {
			chart_state = 'pie_chart';
		}

		this.setState({ chart_state: chart_state });

		if (is_clicked) {
			clearInterval(this.chart_interval);
			this.chart_interval = setInterval(() => { this.changeChartState(false) }, 20000);
		}
	}

	changeTotalState = (is_clicked) => {
		let total_state = this.state.total_state;

		switch (total_state) {
			case 'total_energy':
				if (this.props.param.report_settings.categories.is_energy_generator_enabled) total_state = 'total_energy_gen';
				else if (this.props.param.report_settings.categories.is_water_consumption_enabled) total_state = 'total_water';
				else total_state = 'total_energy';
				break;
			case 'total_energy_gen':
				if (this.props.param.report_settings.categories.is_water_consumption_enabled) total_state = 'total_water';
				else total_state = 'total_energy';
				break;
			case 'total_water':
				total_state = 'total_energy';
				break;
			default:
				total_state = 'total_energy';
		}

		this.setState({ total_state: total_state });

		if (is_clicked) {
			clearInterval(this.total_interval);
			this.total_interval = setInterval(() => { this.changeTotalState(false) }, 20000);
		}
	}

	changeBreakdownState = (is_clicked) => {
		let breakdown_state = this.state.breakdown_state;

		switch (breakdown_state) {
			case 'energy_device':
				if (this.props.param.report_settings.categories.is_show_energy_categories) breakdown_state = 'energy_category';
				else if (this.props.param.report_settings.categories.is_water_consumption_enabled) breakdown_state = 'water_device';
				else breakdown_state = 'energy_device';
				break;
			case 'energy_category':
				if (this.props.param.report_settings.categories.is_water_consumption_enabled) breakdown_state = 'water_device';
				else breakdown_state = 'energy_device';
				break;
			case 'water_device':
				breakdown_state = 'energy_device';
				break;
			default:
				breakdown_state = 'energy_device';
		}

		this.setState({ breakdown_state: breakdown_state });

		if (is_clicked) {
			clearInterval(this.breakdown_interval);
			this.breakdown_interval = setInterval(() => { this.changeBreakdownState(false) }, 20000);
		}
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let is_landscape = (this.props.width >= this.props.height)

		let bg_color = this.props.colours.realtime_bg;

		let timestamp_string = '';
		let locale = getLocale(this.props.receiver.lang);
		let df_options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
		timestamp_string = window.app.state.timestamp.toLocaleString(locale, df_options);

		let chart_height = (this.props.width - 40) / 3 * 2;
		if (is_landscape) {
			chart_height = this.props.width / 3;
			//For web version, if chart height is too big
			if (chart_height > this.props.height - 240 && chart_height > 250) chart_height = this.props.height - 240;
		}

		let total_energy_gen_elem = null;
		let total_water_elem = null;

		let energy_categories_elem = null;
		let water_devices_elem = null;

		if (this.props.param.report_settings.categories.is_energy_generator_enabled) {
			total_energy_gen_elem = <Total_Energy_Generator
				data={this.state.data}
				receiver={this.props.receiver}
				height={this.props.height}
				width={this.props.width}
			/>
		}

		if (this.props.param.report_settings.categories.is_water_consumption_enabled) {
			total_water_elem = <Total_Water_Consumption
				data={this.state.data}
				receiver={this.props.receiver}
				height={this.props.height}
				width={this.props.width}
			/>

			water_devices_elem = <Water_Devices
				data={this.state.data}
				receiver={this.props.receiver}
				height={this.props.height}
				width={this.props.width}
			/>
		}

		if (this.props.param.report_settings.categories.is_show_energy_categories) {
			energy_categories_elem = <Energy_Categories
				data={this.state.data}
				receiver={this.props.receiver}
				height={this.props.height}
				width={this.props.width}
				report_settings={this.props.param.report_settings}
			/>
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('realtime')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div className="noScrollBar" style={{ height: this.props.height - 70, overflow: 'auto' }}>
						<div style={{ textAlign: 'left', paddingLeft: 10, background: bg_color }}>
							<span className="header" style={{ fontSize: 20, color: 'white' }}>{timestamp_string}</span>
						</div>

						<div className='fadeIn realtime_chart' style={{ cursor: 'pointer', display: this.state.chart_state == 'pie_chart' ? 'block' : 'none', background: bg_color, height: chart_height }} onClick={() => { this.changeChartState(true) }}>
							<Categories_Pie_Charts
								ref={this.categories_pie_charts}
								data={this.state.data}
								receiver={this.props.receiver}
								height={this.props.height}
								width={this.props.width}
								report_settings={this.props.param.report_settings}
							/>
						</div>

						<div className='fadeIn realtime_chart' style={{ cursor: 'pointer', display: this.state.chart_state == 'energy_chart' ? 'block' : 'none', background: bg_color, height: chart_height }} onClick={() => { this.changeChartState(true) }}>
							<Total_Hourly_Bar_Chart
								ref={this.total_hourly_bar_chart}
								data={this.state.data}
								receiver={this.props.receiver}
								height={this.props.height}
								width={this.props.width}
							/>
						</div>

						<div className='fadeIn' style={{ cursor: 'pointer', display: this.state.total_state == 'total_energy' ? 'block' : 'none' }} onClick={() => { this.changeTotalState(true) }}>
							<Total_Energy_Consumption
								data={this.state.data}
								receiver={this.props.receiver}
								height={this.props.height}
								width={this.props.width}
							/>
						</div>

						<div className='fadeIn' style={{ display: this.state.total_state == 'total_energy_gen' ? 'block' : 'none' }} onClick={() => { this.changeTotalState(true) }}>
							{total_energy_gen_elem}
						</div>

						<div className='fadeIn' style={{ cursor: 'pointer', display: this.state.total_state == 'total_water' ? 'block' : 'none' }} onClick={() => { this.changeTotalState(true) }}>
							{total_water_elem}
						</div>

						<div className='fadeIn' style={{ cursor: 'pointer', display: this.state.breakdown_state == 'energy_category' ? 'block' : 'none' }} onClick={() => { this.changeBreakdownState(true) }}>
							{energy_categories_elem}
						</div>

						<div className='fadeIn' style={{ cursor: 'pointer', display: this.state.breakdown_state == 'energy_device' ? 'block' : 'none' }} onClick={() => { this.changeBreakdownState(true) }}>
							<Energy_Devices
								data={this.state.data}
								receiver={this.props.receiver}
								height={this.props.height}
								width={this.props.width}
							/>
						</div>

						<div className='fadeIn' style={{ cursor: 'pointer', display: this.state.breakdown_state == 'water_device' ? 'block' : 'none' }} onClick={() => { this.changeBreakdownState(true) }}>
							{water_devices_elem}
						</div>
					</div>
				</div>
			</div>
		)
	}
}